// extracted by mini-css-extract-plugin
export default {"list":"DocumentsCard_list__vpJB+","item":"DocumentsCard_item__zX8dl","download":"DocumentsCard_download__+QfL2","downloadIcon":"DocumentsCard_downloadIcon__B8TE4"};